import React from 'react'
import { Trans } from '@lingui/macro'
import {
  SentimentVeryDissatisfied,
  SentimentDissatisfied,
  SentimentSatisfied,
  SentimentSatisfiedAlt,
  SentimentVerySatisfied,
  HelpOutline
} from '@material-ui/icons'

import { styles, css } from 'helpers'

export const moodOptions = [
  {
    value: 1,
    label: <Trans>Very unlikely</Trans>,
    color: styles.colors.paleRed,
    icon: SentimentVeryDissatisfied
  },
  {
    value: 2,
    label: <Trans>Unlikely</Trans>,
    color: styles.colors.paleOrange,
    icon: SentimentDissatisfied
  },
  {
    value: 3,
    label: <Trans>Neutral</Trans>,
    color: '',
    icon: SentimentSatisfied
  },
  {
    value: 4,
    label: <Trans>Promising</Trans>,
    color: styles.colors.paleGreen,
    icon: SentimentSatisfiedAlt
  },
  {
    value: 5,
    label: <Trans>Very promising</Trans>,
    color: '#0f8e1f',
    icon: SentimentVerySatisfied
  }
]

const moodUnknown = {
  color: '',
  icon: HelpOutline
}

export function Mood({ rating, onClick, size = 24 }) {
  var mood = moodOptions.find(obj => obj.value === rating)
  if (typeof mood === 'undefined') {
    mood = moodUnknown
  }
  const MoodIcon = mood.icon
  return (
    <MoodIcon
      className={css({
        color: mood.color,
        width: size,
        height: size,
        cursor: onClick && 'pointer'
      })}
      onClick={onClick}
    />
  )
}
